import { Component, OnInit } from '@angular/core';
import { CompanyParamsService } from '../../services/company-params.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  public todayDate: number = new Date().getFullYear();
  constructor(
    public companyParamsService: CompanyParamsService
  ) { }

  ngOnInit() {
  }
  configPrivacyUrl() {
    return 'mailto:' + this.companyParamsService.getInfoEmail();
  }
}
